/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSubMenuClick } from "../../../store/slices/SubMenuClick";
import { setData } from "../../../store/slices/TableData";
import Sidebar from "../../../components/AdminComponents/SideNav";
import "../tableStyling.css";
import {
  InteractionTwoTone,
  CheckOutlined,
  CloseOutlined,
  SwapOutlined,
  FolderOpenTwoTone,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Table,
  Tag,
  Spin,
  Popconfirm,
  Pagination,
  Modal,
  Menu,
  Switch,
  Dropdown,
} from "antd";
import EditableImage from "../../../components/icons/EditIcon";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import Axios from "../../../api/Axios";
import { setSubMenuTrakL } from "../../../store/slices/SubMenuTrakL";
import { message } from "antd";
import FilterClients from "../../../components/AdminComponents/Modals/FilterClients";
import { setTnmisSubmenu } from "../../../store/slices/tnmisSubmenu";
import {
  capitalizeWords,
  ModuleColor,
  ModuleTagName,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import { getUpdateStatus1 } from "../../../components/AdminComponents/ViewUpdateIndexTnAdmin";
import { setFilterDataRedux } from "../../../store/slices/filterSlice";
import {
  setClientTypeS,
  setRelationshipTypeS,
  setSelectedActiveStorage,
  setSelectedApplicationsS,
  setSelectedNaicsS,
  setCustomerToClientS,
  setExpiry,
} from "../../../store/slices/filterStateSlice";
import { GetFormattedDate } from "../../../components/utils/DateTimeUtils";
import UserSearch from "../../../components/AdminComponents/Modals/UserSearch";
import { setSearchSlice } from "../../../store/slices/searchSlice";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import UserImpersonateModal from "../../../components/AdminComponents/Modals/UserImpersonateModal";

const Clients = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const dispatch = useDispatch();
  const filterDataRedux = useSelector((state) => state.filter);
  const searchModalState = useSelector((state) => state.search);
  const { isModalVisible } = searchModalState;

  const history = useNavigate();
  const {
    activeStorage,
    statusS,
    relationshipTypeS,
    clientTypeS,
    selectedNaicsS,
    selectedApplicationsS,
    customerToClientS,
  } = useSelector((state) => state.filterState);
  const [visible, setVisible] = useState(false);

  const [relationshipType, setRelationshipType] = useState([]);
  const [clientType, setClientType] = useState([]);

  const [naicsRes, setNaicsRes] = useState([]);
  const [applications, setApplications] = useState([]);
  const [expires, setExpires] = useState();
  const [selectedNaics, setSelectedNaics] = useState("");

  const [selectedApplications, setSelectedApplications] = useState([]);
  const [customerToClient, setCustomerToClient] = useState(false);
  const {
    pageSize,
    currentPage,
    url,
    filter_flag,
    search,
    filters,
    sort_column,
    sort_order,
    newPageSize,
    expiry,
  } = filterDataRedux;
  //console.log(url);
  //console.log(pageSize, newPageSize, "clientFilter");
  const userInfo = useSelector((state) => state.user);
  const [fixLeft, setFixLeft] = useState(false);
  const ResetFields = async () => {
    //console.log("reset from modal");
    let randomItemsLength = Math.floor(Math.random() * 100);
    setRelationshipType([]);
    setClientType([]);
    setNaicsRes([]);
    setSelectedNaics("");
    setSelectedApplications([]);
    setCustomerToClient(false);
    setExpires();
    dispatch(setSelectedActiveStorage(true));
    dispatch(setRelationshipTypeS([]));
    dispatch(setClientTypeS([]));
    dispatch(setSelectedNaicsS(""));
    dispatch(setSelectedApplicationsS([]));
    dispatch(setCustomerToClientS(false));
    dispatch(setExpiry(0));

    dispatch(
      setFilterDataRedux({
        ...filterDataRedux,
        pageSize: 15,
        currentPage: 1,
        url: `/organizationlist/`,
        filter_flag: false,
        itemsLength: randomItemsLength,
        search: "", // Update itemsLength with API response count
      })
    );
    handleCancel();
  };

  const handleRelationshipTypeChange = (checkedValues) => {
    setRelationshipType(checkedValues);
  };

  const handleExpriySelect = (value) => {
    setExpires(value);
  };

  const handleClientTypeChange = (checkedValues) => {
    setClientType(checkedValues);
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const handleApply = async () => {
    //console.log(selectedApplications);

    // setLoading(true);
    let filter_url = "";

    if (relationshipType.length > 0) {
      dispatch(setRelationshipTypeS(relationshipType));
      filter_url += `&relationship_type=${relationshipType.join(",")}`;
    } else {
      dispatch(setRelationshipTypeS([]));
    }

    if (clientType.length > 0) {
      dispatch(setClientTypeS(clientType));
      filter_url += `&org_type=${clientType.join(",")}`;
    } else {
      dispatch(setClientTypeS([]));
    }

    if (selectedNaics) {
      dispatch(setSelectedNaicsS(selectedNaics));
      filter_url += `&naics=${selectedNaics}`;
    } else {
      dispatch(setSelectedNaicsS(""));
    }

    if (selectedApplications.length > 0) {
      dispatch(setSelectedApplicationsS(selectedApplications));
      filter_url += `&application=${selectedApplications.join(",")}`;
    } else {
      dispatch(setSelectedApplicationsS([]));
    }
    if (expires) {
      dispatch(setExpiry(expires));
      filter_url += `&expire_days=${expires}`;
    } else {
      dispatch(setExpiry(0));
    }
    if (customerToClient) {
      dispatch(setCustomerToClientS(customerToClient));
      filter_url += `&customer_to_client=True`;
    } else {
      dispatch(setCustomerToClientS(false));
    }
    //console.log(filter_url, "filter_url");

    //console.log(activeStorage, "active2");
    if (filter_url !== "") {
      dispatch(
        setFilterDataRedux({
          ...filterDataRedux,
          filter_flag: true,
          filters: filter_url,
          currentPage: 1,
        })
      );
    } else {
      dispatch(
        setFilterDataRedux({
          ...filterDataRedux,
          filter_flag: false,
        })
      );
    }

    //console.log(url);

    setVisible(false);
  };
  const showModal = () => {
    setVisible(true);
    if (filter_flag) {
      setRelationshipType(relationshipTypeS);
      setClientType(clientTypeS);
      setSelectedNaics(selectedNaicsS);
      setSelectedApplications(selectedApplicationsS);
      setCustomerToClient(customerToClientS);
    } else {
      setRelationshipType([]);
      setClientType([]);
      setNaicsRes([]);
      setSelectedNaics("");
      setSelectedApplications([]);
      setCustomerToClient(false);
    }
  };
  const LoadUser = async () => {
    try {
      const res = await Axios.get("/applicationlist/?status=True");
      //console.log(res.data);
      setApplications(res.data);
    } catch (err) {
      //console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
    localStorage.removeItem("impersonateCheck");
  }, []);
  useEffect(() => {
    if (sort_column === "name" || sort_column === "client_id") {
      setFixLeft(true);
    } else {
      setFixLeft(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDataRedux]);
  const renderStatus = (text, record) => {
    if (record.status) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };

  // function getDaySuffix(day) {
  //   if (day >= 11 && day <= 13) {
  //     return "th";
  //   }
  //   switch (day % 10) {
  //     case 1:
  //       return "st";
  //     case 2:
  //       return "nd";
  //     case 3:
  //       return "rd";
  //     default:
  //       return "th";
  //   }
  // }
  const getDefaultSortOrder = (column) => {
    if (sort_column === column) {
      return sort_order === "asc" ? "ascend" : "descend";
    }
    return null;
  };
  const [isUserImpersonateModalVisible, setIsUserImpersonateModalVisible] =
    useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [selectedRecordDetails, setSelectedRecordDetails] = useState(null);
  const handleUserImpersonateClick = (record) => {
    setIsUserImpersonateModalVisible(true);
    setSelectedRecord(record);
    setSelectedRecordDetails(record);
  };

  const handleUserImpersonateModalClose = () => {
    setIsUserImpersonateModalVisible(false);
    setSelectedRecord(null);
    setSelectedRecordDetails(null);
  };
  const impersonateMenu = (record) => (
    <Menu>
      <Menu.Item
        key="client-impersonate"
        onClick={() => impersonateUser(record?.id)}
        icon={<TeamOutlined style={{ color: "#1890ff" }} />} // Icon for Client Impersonate
      >
        Client Impersonate
      </Menu.Item>
      <Menu.Item
        key="user-impersonate"
        onClick={() => handleUserImpersonateClick(record)}
        icon={<UserOutlined style={{ color: "#52c41a" }} />} // Icon for User Impersonate
      >
        User Impersonate
      </Menu.Item>
    </Menu>
  );
  const columns2 = [
    {
      title: capitalizeWords("CLIENT ID"),
      dataIndex: "client_id",
      key: "client_id",
      fixed: fixLeft ? null : "left",
      width: 120,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("client_id"),
    },
    {
      title: capitalizeWords("CLIENT NAME"),
      dataIndex: "name",
      key: "name",
      fixed: fixLeft ? null : "left",
      width: 230,
      sorter: true, // Enable sorting for this column
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("name"),
    },
    // {
    //   title: "NAICS DETAILS",
    //   dataIndex: "naics_primary",
    //   key: "naics_primary",
    // },
    {
      title: capitalizeWords("CLIENT TYPE"),
      dataIndex: "org_type",
      key: "org_type",
      width: 150,
    },

    // {
    //   title: "Products",
    //   dataIndex: "applications",
    //   key: "applications",

    //   render: (applications) => (
    //     <span>
    //       {applications.map((tag) => {
    //         console.log(tag);
    //         let color;
    //         if (tag === "Trak Coaching") {
    //           color = "volcano";
    //         } else if (tag === "Trak Learning") {
    //           color = "blue";
    //         } else if (tag === "DelegateHR") {
    //           color = "green";
    //         }
    //         return (
    //           <Tag color={color} key={tag} title={tag}>
    //             {typeof tag === "string"
    //               ? tag.substring(0, 2).toUpperCase()
    //               : ""}
    //           </Tag>
    //         );
    //       })}
    //     </span>
    //   ),
    // },
    {
      title: capitalizeWords("PRODUCTS"),
      dataIndex: "applications",
      key: "applications",
      width: 150,
      render: (applications) => (
        <span>
          {applications.map((tag, index) => {
            return (
              <Tag
                color={ModuleColor(tag.name)}
                key={index}
                title={tag.name}
                style={{ margin: "3px" }}
              >
                <span style={{ color: "black", fontWeight: "500" }}>
                  {ModuleTagName(tag.name)}
                </span>
              </Tag>
            );
          })}
        </span>
      ),
    },
    {
      title: capitalizeWords("USERS"),
      dataIndex: "user_count",
      key: "user_count",
      width: 90,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("user_count"),
    },
    {
      title: capitalizeWords("CONTRACT START"),
      dataIndex: "contract_start_date",
      key: "contract_start_date",
      width: 172,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("contract_start_date"),
      render: GetFormattedDate,
    },
    {
      title: capitalizeWords("CONTRACT END"),
      dataIndex: "contract_end_date",
      key: "contract_end_date",
      width: 155,
      sorter: true,
      sortDirections: ["ascend", "descend"],
      defaultSortOrder: getDefaultSortOrder("contract_end_date"),
      render: GetFormattedDate,
    },
    {
      title: capitalizeWords("STATUS"),
      dataIndex: "status",
      key: "status",
      render: renderStatus,
      width: 100,
      align: "center",
    },
    {
      title: capitalizeWords("RELATIONSHIP TYPE"),
      dataIndex: "relationship_type",
      key: "relationship_type",
      width: 180,
    },
    {
      title: capitalizeWords("RELATIONSHIP MANAGER"),
      dataIndex: "relationship_manager",
      key: "relationship_manager",
      width: 200,
    },
    // {
    //   title: "PURPOSE",
    //   dataIndex: "purpose",
    //   key: "purpose",
    //   width: 150,
    // },

    // {
    //   title: "CREATED AT",
    //   dataIndex: "created_at",
    //   key: "created_at",
    //   render: (text, record) => {
    //     const date = new Date(text);
    //     const month = date
    //       .toLocaleString("default", { month: "short" })
    //       .toUpperCase();
    //     const day = date.getDate();
    //     const suffix = getDaySuffix(day);
    //     const year = date.getFullYear();
    //     const formattedDate = `${day} ${month} ${year}`;
    //     return formattedDate;
    //   },
    // },
    {
      title: capitalizeWords("UPDATED"),
      dataIndex: "updated_at",
      key: "updated_at",
      width: 150,
      render: (text, record) => {
        console.log("Change");
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" });
        const day = date.getDate();
        //const suffix = getDaySuffix(day);
        const year = date.getFullYear();
        const formattedDate = `${month}-${day < 10 ? "0" + day : day}-${year}`;
        return formattedDate;
      },
    },
    ...(getUpdateStatus1(userInfo, 0, 0)
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "actions",
            key: "actions",
            fixed: "right",
            width: 100,
            align: "center",
            onCell: (record) => {
              return {
                onClick: (event) => {
                  event.stopPropagation(); // this will avoid onRow being called
                  // go to placeUrl(routes.platformDetails, {})
                },
              };
            },
            render: (text, record) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                {record?.applications?.length > 0 && (
                  <Dropdown
                    overlay={impersonateMenu(record)}
                    trigger={["click"]}
                  >
                    <InteractionTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "2rem",
                        marginRight: "0.9rem",
                      }}
                      title="Impersonate"
                    />
                  </Dropdown>
                )}
                <EditableImage
                  handleRowClick={handleRowClick}
                  recordId={record.id}
                />
                <Popconfirm
                  title={activeStorage ? "Archive Client" : "Unarchive Client"}
                  description=" "
                  onConfirm={() =>
                    activeStorage ? handleDelete(record) : handleDelete2(record)
                  }
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="leftTop"
                >
                  {activeStorage ? (
                    <FolderOpenTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.9rem",
                        marginLeft: "0.7rem",
                      }}
                      // onClick={() => {
                      //   handleDelete(record);
                      // }}
                      title="Archive"
                      twoToneColor="#eb2f96"
                    />
                  ) : (
                    <SwapOutlined
                      style={{
                        cursor: "pointer",
                        fontSize: "1.8rem",
                        marginLeft: "0.9rem",
                      }}
                      // onClick={() => {
                      //   handleDelete(record);
                      // }}
                      title="Unarchive"
                    />
                  )}
                </Popconfirm>
              </div>
            ),
          },
        ]
      : []),
  ];

  const [data, setData] = useState([]);
  // const [active, setActive] = useState(true);

  const [loading, setLoading] = useState(true);
  // const search = useSelector(((state) => state.search))

  const [itemsLength, setItemsLength] = useState();

  const onShowSizeChange = (page, size) => {
    //console.log(size, "clientFilter");
    dispatch(
      setFilterDataRedux({
        ...filterDataRedux,
        pageSize: size,
        newPageSize: "sdkds",
      })
    );
    onPageChange(page, size);
  };

  const onPageChange = (page, size) => {
    // setFilterData((prevData) => ({
    //   ...prevData,
    //   currentPage: page,
    // }));
    dispatch(
      setFilterDataRedux({
        ...filterDataRedux,
        currentPage: page,
        pageSize: size,
      })
    );
  };
  useEffect(() => {
    dispatch(setSubMenuClick(false));
    dispatch(setSubMenuTrakL(false));
    dispatch(setTnmisSubmenu(false));
    localStorage.removeItem("impersonateCheck");
  }, [dispatch]);
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const impersonateUserAccount = (user_id, client_id) => {
    //console.log(id);
    localStorage.setItem("impersonateOriginalID", userInfo?.data?.id);
    localStorage.setItem("impersonateCheck", "is-superadmin-imp");
    localStorage.setItem("impersonateLoginID", user_id);
    localStorage.setItem("impersonateLoginClientID", client_id);
    history("/traineryone/user/impersonate/login");
  };
  const impersonateUser = (id) => {
    //console.log(id);
    localStorage.setItem("impersonateOriginalID", userInfo?.data?.id);
    localStorage.setItem("impersonateCheck", "is-superadmin-imp");
    localStorage.setItem("impersonateLoginID", id);
    history("/traineryone/client/impersonate/login");
  };
  const handleDelete = async (record) => {
    const updatedValues = {
      status: false,
      client_id: record.client_id,
      name: record.name,
    };
    try {
      await Axios.put(`/organization/${record.id}/`, updatedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      handleApply();
      CreateSuccessfull("Archived");
    } catch (err) {
      //console.log(err);
      CreateFailed("Archived");
    }
  };
  const handleDelete2 = async (record) => {
    const updatedValues = {
      status: true,
      client_id: record.id,
      name: record.name,
    };
    try {
      const res = await Axios.put(
        `/organization/${record.id}/`,
        updatedValues,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      //console.log(res);
      handleApply();
      CreateSuccessfull("Unarchive");
    } catch (err) {
      //console.log(err);
      CreateFailed("Unarchive");
    }
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `Client has been ${props}.`,
      duration: 5,
    });
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `Client has not been ${props}.`,
      duration: 5,
    });
  };

  const handleRowClick = (record) => {
    if (getUpdateStatus1(userInfo, 0, 0)) {
      history(`/admin-manager/clients/profile/${record}`);
    }
  };

  // const fetchTableData = async () => {
  //   let doNothing = false;
  //   let passUrl = `${url}?page=${currentPage}&page_size=${pageSize}`;
  //   if (search?.length > 0) {
  //     if (search.length > 2) {
  //       if (filter_flag) {
  //         passUrl += `&search=${search}&status=${
  //           active ? "True" : "False"
  //         }${filters}`;
  //       } else {
  //         passUrl += `&search=${search}&status=${active ? "True" : "False"}`;
  //       }
  //     } else {
  //       doNothing = true;
  //     }
  //   } else {
  //     if (filter_flag) {
  //       passUrl += `&status=${active ? "True" : "False"}${filters}`;
  //     } else {
  //       passUrl += `&status=${active ? "True" : "False"}`;
  //     }
  //   }
  //   if (!doNothing) {
  //     setLoading(true);
  //     try {
  //       const response = await Axios.get(passUrl);

  //       setData(response.data.results);
  //       setItemsLength(response.data.count);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching table data:", error);
  //     }
  //   }
  // };
  const fetchTableData2 = async () => {
    const {
      pageSize,
      currentPage,
      url,
      filter_flag,
      search,
      filters,
      sort_column,
      sort_order,
    } = filterDataRedux;
    let doNothing = false;
    let passUrl = `${url}?page=${currentPage}&page_size=${pageSize}`;
    if (
      sort_column !== "" &&
      sort_column !== undefined &&
      sort_order !== "" &&
      sort_order !== undefined
    ) {
      passUrl += `&sort_column=${sort_column}&sort_order=${sort_order}`;
    }
    if (search?.length > 0) {
      if (search.length > 2) {
        if (filter_flag) {
          passUrl += `&search=${search}&status=${
            activeStorage ? "True" : "False"
            // here
          }${filters}`;
        } else {
          passUrl += `&search=${search}&status=${
            activeStorage ? "True" : "False"
          }`;
        }
      } else {
        doNothing = true;
      }
    } else {
      if (filter_flag) {
        passUrl += `&status=${activeStorage ? "True" : "False"}${filters}`;
      } else {
        passUrl += `&status=${activeStorage ? "True" : "False"}`;
      }
    }

    if (!doNothing) {
      // dispatch(
      //   setFilterDataRedux({
      //     ...filterDataRedux,

      //     loadingRedux: false, // Update itemsLength with API response count
      //   })
      // );
      setLoading(true);
      try {
        const response = await Axios.get(passUrl);

        // Process fetched data as needed (e.g., update UI state or local component state)
        // For example:
        setData(response.data.results);
        setItemsLength(response.data.count);
        setLoading(false);
        //console.log("Fetched data:", response.data.results);
        //console.log("Total items:", response.data.count);
      } catch (error) {
        console.error("Error fetching table data:", error);
      }
    }
  };

  const handleSearchChange = (event) => {
    dispatch(
      setFilterDataRedux({
        ...filterDataRedux,
        search: event.target.value,
        currentPage: 1, // Update itemsLength with API response count
      })
    );
  };

  const handleSwitchChange = (checked) => {
    let randomItemsLength = Math.floor(Math.random() * 100);
    dispatch(setSelectedActiveStorage(checked));

    if (filters === "" && checked) {
      dispatch(
        setFilterDataRedux({
          ...filterDataRedux,
          search: "",
          currentPage: 1,
          activeRedux: checked,
          itemsLength: randomItemsLength,
          filter_flag: false,
        })
      );
    } else {
      dispatch(
        setFilterDataRedux({
          ...filterDataRedux,
          search: "",
          currentPage: 1,
          activeRedux: checked,
          itemsLength: randomItemsLength,
        })
      );
    }
  };
  const handleSortChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      dispatch(
        setFilterDataRedux({
          ...filterDataRedux,
          sort_column: sorter.field,
          sort_order: sorter.order === "ascend" ? "asc" : "desc",
        })
      );
    } else {
      dispatch(
        setFilterDataRedux({
          ...filterDataRedux,
          sort_column: "",
          sort_order: "",
        })
      );
    }
  };

  useEffect(() => {
    fetchTableData2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDataRedux]);
  return (
    <div>
      <Sidebar props={ClientMenu} showSearch={true}>
        {contextHolder}
        <CommonTopDetails
          title="Clients Summary"
          titleSuffix={`${itemsLength || 0} client(s)`}
          searchPlaceholder="Search by..."
          searchAction={handleSearchChange}
          searchValue={search}
          showAddButton={getUpdateStatus1(userInfo, 0, 0)}
          filterAction={true}
          addButtonProps={{
            modalType: "Redirect",
            redirctlink: "/admin-manager/clients/add-user",
          }}
          filterUrl={filter_flag}
          filterButtonProps={{
            modalType: "PopUP",
            modalProps: showModal,
          }}
          resetButtonProps={{
            modalProps: ResetFields,
          }}
          customContent={
            <Switch
              style={{
                backgroundColor: activeStorage ? "#50C878" : "#FF0000",
                minWidth: "90px",
              }}
              checked={activeStorage}
              disabled={loading}
              onChange={handleSwitchChange}
              checkedChildren="ACTIVE"
              unCheckedChildren="INACTIVE"
            />
          }
        />

        <div className="form-container-3">
          <Spin spinning={loading}>
            <div
              className="table-wrapper"
              style={{ overflowX: "auto", overflowY: "auto" }}
            >
              <Table
                columns={columns2}
                size="small"
                bordered
                rowKey="id"
                scroll={{
                  x: 1000,
                  y: `${remainingViewportHeight(24)}px`,
                }}
                pagination={false}
                onRow={(record) => ({
                  onClick: (event) => {
                    if (
                      event.target.closest(
                        ".ant-table-cell[data-index='actions']"
                      )
                    ) {
                      return;
                    }

                    handleRowClick(record.id);
                  },
                })}
                dataSource={data}
                className="table-container"
                style={{ margin: "1rem" }}
                onChange={handleSortChange}
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "1rem",
                }}
              >
                <Pagination
                  size="small"
                  showSizeChanger
                  onShowSizeChange={onShowSizeChange}
                  onChange={onPageChange}
                  pageSizeOptions={[10, 15, 30, 50, 100]}
                  showQuickJumper
                  current={currentPage}
                  defaultPageSize={pageSize}
                  pageSize={pageSize}
                  total={itemsLength}
                />
              </div>
            </div>
            <FilterClients
              visible={visible}
              statusS={statusS}
              relationshipType={relationshipType}
              clientType={clientType}
              naicsRes={naicsRes}
              applications={applications}
              setApplications={setApplications}
              selectedApplications={selectedApplications}
              setSelectedApplications={setSelectedApplications}
              setNaicsRes={setNaicsRes}
              selectedNaics={selectedNaics}
              handleCancel={handleCancel}
              handleApply={handleApply}
              setSelectedNaics={setSelectedNaics}
              handleClientTypeChange={handleClientTypeChange}
              handleRelationshipTypeChange={handleRelationshipTypeChange}
              customerToClient={customerToClient}
              setCustomerToClient={setCustomerToClient}
              ResetFields={ResetFields}
              page={currentPage}
              size={pageSize}
              handleExpriySelect={handleExpriySelect}
              expires={expires}
            />
          </Spin>
        </div>
      </Sidebar>
      <UserImpersonateModal
        isUserImpersonateModalVisible={isUserImpersonateModalVisible}
        handleUserImpersonateModalClose={handleUserImpersonateModalClose}
        selectedRecord={selectedRecord?.id}
        selectedRecordDetails={selectedRecordDetails || null}
        impersonateUserAccount={impersonateUserAccount}
      />
      <UserSearch isModalOpen={isModalVisible} />
    </div>
  );
};

export default Clients;
